/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import ViewModel from '@bingads-webui-component-legacy/single-list-box/viewmodel/singleListBoxViewModel';
import defaultLayoutTemplate from '@bingads-webui-component-legacy/single-list-box/template/defaultLayout.pug';
import defaultItemTemplate from '@bingads-webui-component-legacy/single-list-box/template/defaultItem.pug';
import paginationTmpl from '@bingads-webui-component-legacy/single-list-box/template/pagination.pug';
import Pagination from '@bingads-webui-component-legacy/pagination/index';
import DataSourcePaginationConnector from '@bingads-webui-component-legacy/connectors/dataSource.pagination';
import '@bingads-webui/kendo/kendo.listview';
import '@bingads-webui-component-legacy/searchbox/ko/searchboxBinding';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/single-list-box');
var defaultTemplates = {
  layoutTemplate: defaultLayoutTemplate({
    i18n: i18n
  }),
  listContainerSelector: '.dlb-source',
  pagerSelector: '.pager-container',
  itemLayoutTemplate: defaultItemTemplate({
    i18n: i18n
  }),
  itemContentSelector: '.dlbItem-content',
  itemContentTemplate: '<span>#:data.name#</span>'
};
var listItemCssClass = 'dlbItem';
var ControlView = Backbone.View.extend({
  initialize: function (options) {
    var self = this;
    self.options = options || ({});
    self._applyDefaultTemplates();
    self.options.features = _.defaults(self.options.features || ({}), {
      filtering: true,
      paging: true
    });
    self._viewModel = new ViewModel(_.pick(self.options, 'data', 'itemActions', 'strings', 'features', 'customData', 'processItem'));
    self.refreshItem = _.bind(self._viewModel.refreshItem, self._viewModel);
    self.selectItem = _.bind(self._viewModel.setSelectedItem, self._viewModel);
    self.refreshSource = _.bind(self._viewModel.refreshSource, self._viewModel);
    self._viewModel.selectedItem.subscribe(function (newSelection) {
      self.trigger('selectionChanged', newSelection);
    });
    self._initializeActions();
    self._initializeEventHandlers();
  },
  render: function () {
    var self = this;
    self._renderLayout();
    self._renderList();
    if (self.options && self.options.features && self.options.features.paging) {
      self._initializePager();
    }
    return self;
  },
  _renderLayout: function () {
    var self = this;
    self.$wrapper = $('<div/>').appendTo(self.$el).html(self.options.templates.layoutTemplate);
    ko.applyBindings(self._viewModel, self.$wrapper[0]);
    self.elements = {
      $list: self.$(self.options.templates.listContainerSelector)
    };
  },
  _renderList: function () {
    var self = this;
    self.elements.$list.kendoListView({
      navigatable: true,
      selectable: true,
      change: _.partial(self._onSelectChange, self),
      dataSource: self._viewModel.kendoDataSource,
      template: self._getEffectiveItemTemplate(self.options.templates.itemLayoutTemplate, self.options.templates.itemContentTemplate)
    });
  },
  _getEffectiveItemTemplate: function (layoutTemplate, contentTemplate) {
    return layoutTemplate.replace('<!--content-->', contentTemplate);
  },
  _initializeEventHandlers: function () {
    var self = this;
    self.events = self.events || ({});
    var getEventHandler = function (dataSource, callback, eventType, eventName) {
      var proxy = _.bind(callback, self);
      return function (event) {
        var $itemelement = $(event.target).closest('.' + listItemCssClass);
        var item = dataSource.getItemData($itemelement.attr('data-id'));
        proxy(item);
        self.trigger(eventType, eventName, item);
      };
    };
    _.each(self.itemActions, function (action, key) {
      if (key !== 'select') {
        self.events['click .itemAction-' + key] = getEventHandler(self._viewModel.dataSource, action.callback, 'itemAction', key);
      }
    });
  },
  _onSelectChange: function (view) {
    var selectAction = view.itemActions['select'];
    if (selectAction) {
      var $itemelement = $(this.select());
      if ($itemelement.find('.itemAction-select').length) {
        var item = view._viewModel.dataSource.getItemData($itemelement.attr('data-id'));
        selectAction.callback(item);
        view.trigger('itemAction', 'select', item);
      }
    }
  },
  _applyDefaultTemplates: function () {
    var self = this;
    self.options.templates = self.options.templates || ({});
    _.defaults(self.options.templates, defaultTemplates);
  },
  _initializeActions: function () {
    var self = this;
    self.itemActions = {
      select: {
        callback: self.selectItem
      }
    };
    _.extend(self.itemActions, self.options.itemActions || ({}));
  },
  _initializePager: function () {
    var self = this;
    var pagerEl = self.$(self.options.templates.pagerSelector);
    if (!pagerEl.length) {
      return;
    }
    var dataSource = self._viewModel.kendoDataSource;
    var pagination = new Pagination({
      el: pagerEl,
      template: paginationTmpl,
      i18n: i18n,
      page_size: dataSource.pageSize(),
      page_number: 0,
      item_count: dataSource.total()
    }).render();
    self.dataSource_pagination_connector = new DataSourcePaginationConnector(dataSource, pagination).connect();
  }
});
export default ControlView;

